import qs from "qs";

export const isIe = /trident|msie/.test(
  navigator.userAgent.toLocaleLowerCase()
);

/**
 * url添加参数，存在就覆盖
 * @param url
 * @param key
 * @param value
 */
export const urlAppendQuery = (url = "", query = {}) => {
  if (!url) return url;
  let urlArr = url.split("?");
  let path = urlArr[0];
  let queryStr = urlArr[1];
  if (queryStr) {
    query = { ...qs.parse(queryStr), ...query };
  }
  return path + "?" + qs.stringify(query);
};

/**
 * 获取url上的参数
 * @param key
 * @returns {string|null}
 */
export const queryUrlVal = (key) => {
  const reg = RegExp("(^|&)" + key + "=([^&]*)(&|$)");
  const val = window.location.search.substr(1).match(reg);
  return val ? unescape(val[2]) : null;
};

/**
 * 浅克隆
 * @param value
 */
export const clone = (value) => {
  return JSON.parse(JSON.stringify(value));
};

/**
 * 深克隆
 * @param value
 * @returns {*}
 */
export const cloneDeep = (value) => {
  const isObject = (value) => {
    let type = typeof value;
    return value !== null && (type === "object" || type === "function");
  };
  const getTag = (value) => Object.prototype.toString.call(value);
  const dateTag = "[object Date]";
  const regExpTag = "[object RegExp]";
  //缓存已经copy过的对象，用来处理循环引用问题
  const cache = new WeakMap();

  const _clone = (value) => {
    //原始数据直接返回
    if (!isObject(value)) return value;

    let result;
    let isArr = Array.isArray(value);
    let tag = getTag(value);

    if (isArr) {
      result = [];
    } else if (regExpTag === tag) {
      // 对正则对象做特殊处理
      result = new RegExp(value.source, /\w*$/.exec(value));
      result.lastIndex = value.lastIndex;
    } else if (dateTag === tag) {
      // 对Date对象做特殊处理
      result = new Date(value.getTime());
    } else {
      //普通对象，处理原型对象
      result = Object.create(value.__proto__);
    }

    // 处理循环引⽤
    if (cache.has(value)) {
      // 如果⽗数组存在本对象,说明之前已经被引⽤过,直接返回此对象
      return cache.get(value);
    }
    cache.set(value, result);

    for (let i in value) {
      result[i] = _clone(value[i]);
    }
    return result;
  };

  return _clone(value);
};

/**
 * 生成UUID
 * @param	len UUID的长度
 * @param	radix 进制格式 2、10、16
 * @returns {string}
 * @constructor
 */
export const UUID = (len = 32, radix = 16) => {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const uuid = new Array(len).fill("");
  for (let i = 0; i < len; i++) {
    const index = Math.floor(0 || Math.random() * radix);
    uuid[i] = chars[index];
  }
  return uuid.join("");
};

/**
 * url跳转 - 新开标签页
 * @param link
 */
export const jumpLink = (link) => {
  if (!link) return;
  let a = document.createElement("a");
  a.setAttribute("href", link);
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/** 引入第三方js插件 */
export const loadJs = (obj, url, callback) => {
  if (obj) {
    return callback();
  }
  const script = document.createElement("script");
  script.type = "text/javascript";
  if (Object.prototype.toString.call(callback) === "[object Function]") {
    if (script.readyState) {
      script.onreadystatechange = () => {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = callback;
    }
  }
  script.src = url;
  document.body.appendChild(script);
};
